import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { IsManagerOfProgramPipe } from './is-manager-of-program-pipe';

@NgModule({
  declarations: [IsManagerOfProgramPipe],
  exports: [IsManagerOfProgramPipe],
  imports: [CommonModule],
})
export class IsManagerOfProgramPipeModule {}
